import React, { useState, useEffect } from "react";
import { Switch, Route, useHistory, Router, Link, useParams } from "react-router-dom"
import AppCard from '../Applications/AppCard'
import CloudContent from "./CloudContent";
import Grid from "@material-ui/core/Grid";
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import clsx from "clsx";
import axios from 'axios'
import config from '../../other/config';
const { serverAPI } = config;

export default function CloudListRouter(props) {
	let { IsRu, setIsRu, handleExpandClick, basketChips, cloudBasket, setBasketCloud, appBasket, setAppBasket, language } = props
	let { bank } = useParams();
	let history = useHistory()
	const classes = useStyles();
	const [bankinfo, setBankinfo] = useState([]);
	const [first, setFirts] = useState(true);

	useEffect(() => {
		if (first) {
			//handleExpandClick(1)  Tarasenko логика перенесена на LeftBar
			setFirts(false)
		}
	}, [bank]);
	// useEffect(() => {
	// 	let didCancel = false;
	// 	async function fetchData() {
	// 		const _bankinfo = await axios.get(`${serverAPI}/bankinfo/${bank}/${props.selectedIndex}`)
	// 		if (!didCancel) {
	// 			if (_bankinfo && _bankinfo.data) {
	// 				setBankinfo(_bankinfo.data[0])
	// 			}
	// 		}
	// 	}
	// 	fetchData();
	// 	return () => {
	// 		didCancel = true;
	// 	}
	// }, [bank]);
	return (
		<React.Fragment>
			<Grid container /* style={{ outline: '1px solid blue' }} */>
				<div className={classes.container} style={{ width: '100%' }}>
					<div>
						<Switch>
							<Router history={history}>
								<Route exact path='/cloud/:bank/overview'>
									<CloudContent
										setErr={props.setErr}
										readlink={bankinfo.LinkActive === 0}
										IsRu={IsRu}
										cloudBasket={cloudBasket}
										appBasket={appBasket}
										setAppBasket={setAppBasket}
										setBasketCloud={setBasketCloud}
										basketChips={basketChips}
										language={language}
									/>
								</Route>

								<Route exact path='/cloud/:bank/card/:code'>
									<AppCard
										isAuth={props.isAuth}
										usname={props.usname}
										IsRu={IsRu}
										setIsRu={setIsRu}
										basketChips={basketChips}
										setAppBasket={setAppBasket}
										language={language}
									/>
								</Route>
							</Router>

							{
								window.location.pathname.substr(0, window.location.pathname.lastIndexOf('/')) !== `/cloud/${bank}/card/`
									?
									window.location.pathname.substr(-8) == 'overview'
										?
										null
										:
										props.setErr(true)
									:
									null
								// console.log(window.location.pathname.lastIndexOf('/'))
							}
						</Switch>
					</div>
				</div>
			</Grid>
		</React.Fragment>
	)
}

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3} style={{ padding: 0, backgroundColor: 'transparent' }} >
					<Grid>{children}</Grid>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};
const AntTabs = withStyles({
	root: {
		borderBottom: "1px solid #e8e8e8",
	},
	indicator: {
		backgroundColor: "gray"
	}
})(Tabs);

const AntTab = withStyles((theme) => ({
	root: {
		textTransform: "none",
		minWidth: 110,
		padding: '3px 6px',
		fontWeight: theme.typography.fontWeightRegular,
		fontSize: 16,
		lineHeight: '24px',
		color: '#8987A2',
		"&:hover": {
			opacity: 1
		},
		"&$selected": {
			color: "#000000",
			fontWeight: theme.typography.fontWeightRegular
		},
		"&:focus": {
		}
	},
	selected: {}
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles(theme => ({
	// root: {
	// 	display: "flex"
	// },

	toolbar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		padding: theme.spacing(0, 1),
		// necessary for content to be below app bar
		...theme.mixins.toolbar
	},

	content: {
		flexGrow: 1,
		padding: 0,
		paddingTop: theme.spacing(3),
		marginTop: theme.spacing(12),
		// backgroundColor: 'inherit'
	},

	contentOpen: {
		width: `calc(100% - 668px)`,

		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
	},

	contentClose: {
		width: `calc(100% - 218px)`,

		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),

		[theme.breakpoints.down(1366)]: {
			width: '100%'
		}
	},

	container: {
		margin: '72px auto 0',
		'&:first-child': {
			margin: '0 auto'
		},
		[theme.breakpoints.down(696)]: {
			maxWidth: 'calc(336px * 1)',
		},
		[theme.breakpoints.between(696, 1030)]: {
			maxWidth: 'calc(336px * 2)',
		},
		[theme.breakpoints.between(1030, 1366)]: {
			maxWidth: 'calc(336px * 3)',
		},
		[theme.breakpoints.between(1366, 1702)]: {
			maxWidth: 'calc(336px * 3)',
		},
		[theme.breakpoints.up(1702)]: {
			maxWidth: 'calc(336px * 4)',
		}
	},

	containerImage: {
		[theme.breakpoints.down(1702)]: {
			minWidth: '100%',
		},
	},

	containerInfo: {
		[theme.breakpoints.down(1702)]: {
			display: 'none',
		},
	},

	listItem: {
		padding: theme.spacing(1, 1)
	},

	listItemText: {
		padding: theme.spacing(1, 1)
	},

	paper: {
		padding: theme.spacing(3),
		textAlign: "center",
		color: theme.palette.text.secondary,
		boxShadow: '6px 6px 15px rgba(64, 102, 199, 0.02)',
		borderRadius: theme.spacing(2)
	},

	sectionTitle: {
		fontSize: 40,
		fontWeight: 500,
	},

	imgCntr: {
		margin: 'auto',
		display: 'block',
		maxWidth: '100%',
		maxHeight: '100%',
		backgroundImage: 'url(./images/BannerDesctop.png)',
		borderRadius: 24
	},

	footer: {
		fontSize: '16px',
		lineHeight: '24px',
		color: '#8987A2',
		padding: '36px 0'
	},

	btnFilter: {
		backgroundColor: '#FFF',
		borderRadius: '16px',
		'&:focus': {
			borderRadius: '16px'
		}
	},

	tHeader: {
		fontSize: '16px',
		lineHeight: '24px',
		color: '#8987A2',
		fontWeight: 400
	},

	backToList: {
		fontSize: '12px',
		lineHeight: '14px',
		color: '#8987A2'
	},

	search: {
		position: 'relative',
		borderRadius: 24,
		backgroundColor: 'transparent',
		marginLeft: 0,
		marginRight: theme.spacing(1),
		width: 'auto',
		height: 48,

		[theme.breakpoints.down(1366)]: {
			backgroundColor: 'transparent'
		}
	},

	searchIcon: {
		padding: theme.spacing(0, 2),
		height: '100%',
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: '#8987A2',
		paddingLeft: 0,
		// right: 0
	},

	inputRoot: {
		color: '#8987A2',
	},

	inputInput: {
		padding: theme.spacing(1, 2),
		// vertical padding + font size from searchIcon
		paddingLeft: `calc(1em + ${theme.spacing(2)}px)`,
		transition: theme.transitions.create('width'),
		width: 232,
		height: 32,
		[theme.breakpoints.down(1366)]: {
			width: 0,
			'&:focus': {
				width: 207,
			},
		},
		color: '#8987A2'
	},

	root: {
		flexGrow: 1
	},
	padding: {
		padding: theme.spacing(1)
	},
	demo1: {
		backgroundColor: theme.palette.background.paper
	},
	demo2: {
		backgroundColor: "#2e1534"
	},

	cntrAppCardTop: {
		padding: '36px 0'
	}
}));